import * as React from "react";
import { gql, useMutation } from "@apollo/client";
import {
  UpdatePasswordChangeAdminMutationMutation,
  UpdatePasswordChangeAdminMutationMutationVariables
} from "../../../../schemaTypes";
import { normalizeErrors } from "../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../types/NormalizedErrorMap";

const updatePasswordChangeAdminMutation = gql`
  mutation UpdatePasswordChangeAdminMutation(
    $oldPassword: String!
    $newPassword: String!
    $confirmNewPassword: String!
  ) {
    updatePasswordChangeAdmin(
      oldPassword: $oldPassword,
      newPassword: $newPassword,
      confirmNewPassword: $confirmNewPassword
    ) {
      path
      message
    }
  }
`;

interface Props {
  children: (
    data: {
      submit: (
        values: UpdatePasswordChangeAdminMutationMutationVariables
      ) => Promise<NormalizedErrorMap | null>;
    }
  ) => React.ReactElement | null;
}

export const UpdatePasswordAdminController: React.FC<Props> = ({ children }) => {
  const [_updatePasswordChangeAdminMutation] = useMutation<
    UpdatePasswordChangeAdminMutationMutation,
    UpdatePasswordChangeAdminMutationMutationVariables
  >(updatePasswordChangeAdminMutation);

  const submit = async (values: UpdatePasswordChangeAdminMutationMutationVariables) => {
    const { data } = await _updatePasswordChangeAdminMutation({ variables: values });
    if (data?.updatePasswordChangeAdmin) {
      return normalizeErrors(data.updatePasswordChangeAdmin);
    }
    return null;
  };

  return children({ submit });
};